module.exports = __webpack_public_path__ + "static/1217582444.bdd5eeec.jpg";